module.exports = ":host ::ng-deep mat-table {\n  margin: 20px;\n  padding: 20px !important;\n  max-width: 1200px; }\n\n:host ::ng-deep mat-card {\n  margin: 20px;\n  padding: 20px !important;\n  max-width: 1200px; }\n\n:host ::ng-deep mat-form-field {\n  width: 30%;\n  padding: 0 10px; }\n\n:host ::ng-deep .checkbox-container {\n  width: 30%;\n  display: inline-block;\n  padding: 0 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/components/user/user.component.scss
// module id = ./src/app/modules/users/components/user/user.component.scss
// module chunks = main